import { useLayoutEffect, useRef, useState } from 'react';

export function useFitScale(nativeWidth: number, nativeHeight: number) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (!entry) return;
      const { width, height } = entry.contentRect;
      if (width <= 0 || height <= 0) return;
      setScale(Math.min(width / nativeWidth, height / nativeHeight, 1));
    });

    observer.observe(container);
    return () => observer.disconnect();
  }, [nativeWidth, nativeHeight]);

  return { containerRef, scale };
}
